module.exports = __webpack_public_path__ + "img/certificate-2.abf04e59.png";